import { forwardRef, type Ref, type SVGProps } from 'react';
import { SvgIcon } from '../../components/icon/icon';

interface SVGRProps {
  title?: string;
  titleId?: string;
}
const QuestionCircle = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    ref={ref}
    aria-labelledby={titleId}
    {...props}>
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="currentColor"
      d="M10.705 13.72v-.417q0-.383.107-.675a1.7 1.7 0 0 1 .343-.563q.237-.27.625-.552.349-.247.557-.445.214-.196.31-.388a.96.96 0 0 0 .101-.445q0-.366-.27-.557t-.754-.191-.963.152a6.6 6.6 0 0 0-.962.4l-.614-1.234q.563-.315 1.222-.506a5 5 0 0 1 1.44-.197q1.206 0 1.864.58.664.573.664 1.463 0 .473-.152.822a2 2 0 0 1-.45.642 7 7 0 0 1-.749.619 6 6 0 0 0-.518.417 1 1 0 0 0-.247.337 1.1 1.1 0 0 0-.062.4v.338zm-.18 1.925q0-.529.287-.743a1.16 1.16 0 0 1 .704-.214q.4 0 .686.214.293.213.293.743 0 .507-.293.732-.287.225-.687.225a1.12 1.12 0 0 1-.703-.225q-.287-.225-.287-.732"
      vectorEffect="non-scaling-stroke"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
const ForwardRef = forwardRef(QuestionCircle) as SvgIcon;
export { ForwardRef as ReactComponent };
